import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Link } from "react-router-dom";

interface TermsAcceptanceCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

const TermsAcceptanceCheckbox = ({ checked, onCheckedChange }: TermsAcceptanceCheckboxProps) => {
  return (
    <div className="flex items-start gap-3 p-4 bg-muted/30 border border-border rounded-lg animate-fade-in">
      <Checkbox
        id="terms-acceptance"
        checked={checked}
        onCheckedChange={onCheckedChange}
        className="mt-0.5"
      />
      <Label
        htmlFor="terms-acceptance"
        className="text-sm text-muted-foreground leading-relaxed cursor-pointer"
      >
        J'accepte les{" "}
        <Link
          to="/cgu"
          className="text-primary hover:underline font-medium"
          target="_blank"
        >
          Conditions Générales d'Utilisation
        </Link>
        {" "}et la{" "}
        <Link
          to="/privacy-policy"
          className="text-primary hover:underline font-medium"
          target="_blank"
        >
          Politique de Confidentialité
        </Link>
      </Label>
    </div>
  );
};

export default TermsAcceptanceCheckbox;
